import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

// Define your custom color shades


const jet = { DEFAULT: '#363535', 100: '#0b0b0b', 200: '#161515', 300: '#202020', 400: '#2b2a2a', 500: '#363535', 600: '#5f5d5d', 700: '#878585', 800: '#afaeae', 900: '#d7d6d6' };
const medium_blue = { DEFAULT: '#2f609e', 100: '#09131f', 200: '#13263f', 300: '#1c395e', 400: '#264c7e', 500: '#2f609e', 600: '#437cc7', 700: '#729dd5', 800: '#a1bde3', 900: '#d0def1' };
const dark_blue = { DEFAULT: '#17314f', 100: '#050a10', 200: '#091420', 300: '#0e1d2f', 400: '#12273f', 500: '#17314f', 600: '#29588e', 700: '#4180c8', 800: '#81aada', 900: '#c0d5ed' };
const light_blue = { DEFAULT: '#67cae0', 100: '#0b2e36', 200: '#165d6c', 300: '#218ba3', 400: '#30b7d5', 500: '#67cae0', 600: '#85d4e6', 700: '#a4dfec', 800: '#c2eaf3', 900: '#e1f4f9' };
const black = { DEFAULT: '#000000', 100: '#000000', 200: '#000000', 300: '#000000', 400: '#000000', 500: '#000000', 600: '#333333', 700: '#666666', 800: '#999999', 900: '#cccccc' };
const white = { DEFAULT: '#ffffff' }

const ThemePreset = definePreset(Aura, {
    theme: {
        extend: {
            colors: {
                colorScheme: {
                    light: {
                        tertiary: 'yellow'
                    },
                    dark: {
                        tertiary: 'red'
                    }
                }
            }
        }
    },
    semantic: {
        primary: light_blue,
        secondary: black,
        colorScheme: {
            light: {
                surface: white,
                primary: {
                    color: dark_blue, 
                    background: white,
                    inverseColor: dark_blue[200], 
                    hoverColor: dark_blue[500], 
                    activeColor: dark_blue[600] 
                },
                highlight: {
                    background: medium_blue[500],
                    focusBackground: medium_blue[500],
                    color: jet[700],
                    focusColor: jet[800]
                }
            },
            dark: {
                surface: black,
                primary: {
                    background: light_blue,
                    color: light_blue[500], 
                    inverseColor: jet[100],
                    hoverColor: light_blue[400], 
                    activeColor: light_blue[600] 
                },
                highlight: {
                    background: medium_blue[500],
                    focusBackground: medium_blue[500],
                    color: jet[200],
                    focusColor: jet[100]
                },
                jet: {
                    background: dark_blue[500],
                    focusBackground: dark_blue[500],
                    color: jet[200],
                    focusColor: jet[100]
                }
            }
        }
    },
    components: {
        card: {
            colorScheme: {
                light: {
                    root: {
                        background: '{dark_blue.500}',
                        color: '{surface.700}'
                    },
                    subtitle: {
                        color: '{surface.500}'
                    }
                },
                dark: {
                    root: {
                        background: '{surface.400}',
                        color: '{light-blue.300}'
                    },
                    subtitle: {
                        color: '{medium-blue.200}'
                    }
                }
            }
        }
    }
});

export default ThemePreset;
